import React, { memo } from 'react';
import './MultiviewLayout.css';

const MultiviewLayout = memo(({ videoComponent, mapComponent, telemetryComponent }) => {
  return (
    <div className="multiview-layout">
      <div className="multiview-section multiview-map">
        {mapComponent}
      </div>
      <div className="multiview-section multiview-video">
        {videoComponent}
      </div>
      <div className="multiview-section multiview-telemetry">
        {telemetryComponent}
      </div>
    </div>
  );
});

MultiviewLayout.displayName = 'MultiviewLayout';

export default MultiviewLayout;


